"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTileWalkable = exports.getSpotVisiblityIIJ = exports.getSpotVisiblity = exports.wasSpotVisibleToHero = exports.isSpotVisibleToHero = exports.fillRect = void 0;
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTilemap_sidecar_1 = require("./diveTilemap-sidecar");
var diveTilemapPart_sidecar_1 = require("./diveTilemapPart-sidecar");
var diveTilemap_generic_sidecar_1 = require("./diveTilemap_generic-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
function fillRect(obj, x, y, w, h, tile) {
    for (var j = y; j < y + h; j++) {
        for (var i = x; i < x + w; i++) {
            var t = diveTilemap_generic_sidecar_1.diveTilemap_generic.getSafe(obj, i, j);
            if (t) {
                diveTilemapPart_sidecar_1.diveTilemapPart.setTile(t, tile);
            }
        }
    }
}
exports.fillRect = fillRect;
// TODO: this doesn't work yet
function isSpotVisibleToHero(gs) {
    return gs.visibilityIdx === diveSimulationManager_sidecar_1.diveSimulationManager.getCurrentVisibilityIndex(); // TODO: make more generic?
}
exports.isSpotVisibleToHero = isSpotVisibleToHero;
function wasSpotVisibleToHero(gs) {
    return gs.visibilityIdx > 0; // TODO: make more generic?
}
exports.wasSpotVisibleToHero = wasSpotVisibleToHero;
function getSpotVisiblity(gs) {
    var isVisible = gs.visibilityIdx === diveSimulationManager_sidecar_1.diveSimulationManager.getCurrentVisibilityIndex(); // TODO: make more generic?
    if (isVisible) {
        return 2;
    }
    var wasVisible = gs.visibilityIdx > 0;
    if (wasVisible) {
        return 1;
    }
    return 0;
}
exports.getSpotVisiblity = getSpotVisiblity;
function getSpotVisiblityIIJ(iij) {
    var gs = diveTilemap_sidecar_1.diveTilemap.getSafeIIJ(iij);
    if (!gs) {
        return 0;
    }
    return getSpotVisiblity(gs);
}
exports.getSpotVisiblityIIJ = getSpotVisiblityIIJ;
function isTileWalkable(tile) {
    if (!tile) {
        return false;
    }
    if (!tile.tile1.canWalk) {
        return false;
    }
    if (tile.objects.length > 0) {
        for (var iObj = 0; iObj < tile.objects.length; iObj++) {
            var obj = tile.objects[iObj];
            if (!diveObjects_sidecar_1.diveObjects.isWalkable(obj)) {
                return false;
            }
        }
    }
    return true;
}
exports.isTileWalkable = isTileWalkable;
